import { http } from "./http"

export const getSettings = () => {
  return http.get("/complex/settings")
}
